// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/goal.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateGoalRequest, CreateGoalResponse, DeleteGoalRequest, DeleteGoalResponse, ListGoalsRequest, ListGoalsResponse, ListPresetsRequest, ListPresetsResponse, SeedPresetGoalsRequest, SeedPresetGoalsResponse, UpdateGoalRequest, UpdateGoalResponse } from "./goal_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.GoalService
 */
export const GoalService = {
  typeName: "tracker.v1.GoalService",
  methods: {
    /**
     * @generated from rpc tracker.v1.GoalService.ListGoals
     */
    listGoals: {
      name: "ListGoals",
      I: ListGoalsRequest,
      O: ListGoalsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.GoalService.CreateGoal
     */
    createGoal: {
      name: "CreateGoal",
      I: CreateGoalRequest,
      O: CreateGoalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.GoalService.UpdateGoal
     */
    updateGoal: {
      name: "UpdateGoal",
      I: UpdateGoalRequest,
      O: UpdateGoalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.GoalService.DeleteGoal
     */
    deleteGoal: {
      name: "DeleteGoal",
      I: DeleteGoalRequest,
      O: DeleteGoalResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.GoalService.ListPresets
     */
    listPresets: {
      name: "ListPresets",
      I: ListPresetsRequest,
      O: ListPresetsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.GoalService.SeedPresetGoals
     */
    seedPresetGoals: {
      name: "SeedPresetGoals",
      I: SeedPresetGoalsRequest,
      O: SeedPresetGoalsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

